import { createFileRoute, Link } from "@tanstack/react-router";
import { useAdminStore } from "@/store";
import { queryClient } from "@/lib/query-client";

export const Route = createFileRoute("/access-denied")({
  component: AccessDeniedPage,
});

function AccessDeniedPage() {
  const clearAuth = useAdminStore((s) => s.clearAuth);

  function handleLogout() {
    clearAuth();
    queryClient.clear();
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50">
      <div className="w-full max-w-md rounded-xl bg-white p-8 text-center shadow-lg">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
          <svg
            className="h-8 w-8 text-red-600"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
            />
          </svg>
        </div>

        <h1 className="mb-2 text-2xl font-bold text-slate-900">Access Denied</h1>

        <p className="mb-6 text-sm text-slate-500">
          This portal requires the <strong>super_admin</strong> role. Your current account does not
          have the required permissions. Please contact a system administrator if you believe this
          is an error.
        </p>

        <Link
          to="/login"
          onClick={handleLogout}
          className="inline-flex items-center gap-2 rounded-lg bg-primary px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-primary-hover"
        >
          Sign out and return to login
        </Link>
      </div>
    </div>
  );
}
